document.addEventListener("DOMContentLoaded", function () {
  console.log("Initializing color swatch handler...");
  
  // Store all variant data maps globally for easy access
  var allVariantData = {};
  
  // Function to collect all variant data maps
  function collectVariantData() {
    Object.keys(window).forEach(function(key) {
      if (key.startsWith("variantDataMap")) {
        var sectionId = key.replace("variantDataMap", "").replace(/_/g, "-");
        allVariantData[sectionId] = window[key];
        console.log("Found variant data for section:", sectionId);
      }
    });
  }
  
  // Collect variant data initially
  collectVariantData();
  
  // Function to handle swatch changes
  function handleSwatchChange(input) {
    var card = input.closest(".card-product-custom-div");
    
    if (!card) {
      console.log("Card container not found");
      return;
    }
    
    var variantId = input.getAttribute("data-variant-id");
    var sectionId = input.getAttribute("data-section-id");
    
    if (!variantId) {
      console.log("No variant ID found");
      return;
    }
    
    console.log("Swatch clicked - Variant ID:", variantId, "Section:", sectionId);
    
    // Try to find variant data in multiple ways
    var variantData = null;
    
    // Method 1: Use section-specific data
    if (sectionId && allVariantData[sectionId]) {
      variantData = allVariantData[sectionId][variantId];
    }
    
    // Method 2: Try with underscore format
    if (!variantData && sectionId) {
      var underscoreSectionId = sectionId.replace(/-/g, "_");
      if (allVariantData[underscoreSectionId]) {
        variantData = allVariantData[underscoreSectionId][variantId];
      }
    }
    
    // Method 3: Search through all variant data
    if (!variantData) {
      Object.keys(allVariantData).forEach(function(key) {
        if (!variantData && allVariantData[key][variantId]) {
          variantData = allVariantData[key][variantId];
        }
      });
    }
    
    // Method 4: Try to get data from the input itself
    if (!variantData) {
      var imageUrl = input.getAttribute("data-image-url");
      var productUrl = input.getAttribute("data-product-url");
      
      if (imageUrl) {
        variantData = {
          imageUrl: imageUrl,
          productUrl: productUrl || card.querySelector("a")?.href
        };
      }
    }
    
    if (!variantData) {
      console.log("No variant data found for:", variantId);
      // Try to refresh variant data maps
      collectVariantData();
      return;
    }
    
    console.log("Variant data found:", variantData);
    
    // Update the product image
    var productImageElement = card.querySelector(".card__media img");
    
    if (productImageElement) {
      var lazyLoadAllVariants = card.getAttribute("data-lazy-load-all-variants") === "true";
      
      if (lazyLoadAllVariants) {
        // Look for preloaded image
        var preloadedImage = card.querySelector(`img[data-variant-id="${variantId}"]`);
        
        if (preloadedImage) {
          console.log("Using preloaded image");
          productImageElement.src = preloadedImage.src;
          productImageElement.srcset = preloadedImage.srcset || "";
          if (preloadedImage.alt) {
            productImageElement.alt = preloadedImage.alt;
          }
        } else if (variantData.imageUrl) {
          console.log("Preloaded image not found, using dynamic URL");
          updateImageWithUrl(productImageElement, variantData.imageUrl);
        }
      } else if (variantData.imageUrl) {
        console.log("Updating image with dynamic URL");
        updateImageWithUrl(productImageElement, variantData.imageUrl);
      }
      
      // Force image reload by removing loading attribute
      productImageElement.removeAttribute("loading");
      productImageElement.setAttribute("loading", "eager");
    } else {
      console.log("Product image element not found");
    }
    
    // Update product links
    if (variantData.productUrl) {
      var productLinks = card.querySelectorAll('a[href*="/products/"]');
      
      productLinks.forEach(function (link) {
        link.href = variantData.productUrl;
        console.log("Updated link:", variantData.productUrl);
      });
    }
  }
  
  // Function to update image with URL
  function updateImageWithUrl(imgElement, imageUrl) {
    var dynamicSrcset = [
      imageUrl + "?width=533 165w",
      imageUrl + "?width=533 360w",
      imageUrl + "?width=533 533w",
      imageUrl + "?width=720 720w",
      imageUrl + "?width=940 940w",
      imageUrl + "?width=1066 1066w"
    ].join(", ");
    
    imgElement.srcset = dynamicSrcset;
    imgElement.src = imageUrl;
  }
  
  // Use a single global event listener on document for better compatibility
  document.addEventListener("change", function (e) {
    if (e.target.matches('input[type="radio"]') && e.target.hasAttribute("data-variant-id")) {
      handleSwatchChange(e.target);
    }
  }, true); // Use capture phase
  
  // Also listen for click events
  document.addEventListener("click", function (e) {
    var input = e.target.closest('input[type="radio"][data-variant-id]');
    if (input) {
      // Small delay to ensure the input is checked
      setTimeout(function() {
        if (input.checked) {
          handleSwatchChange(input);
        }
      }, 10);
    }
  }, true);
  
  // Refresh variant data when new content is loaded (for infinite scroll/lazy load)
  var observer = new MutationObserver(function(mutations) {
    var shouldRefresh = false;
    
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && (node.classList?.contains("card-product-custom-div") || node.querySelector?.(".card-product-custom-div"))) {
          shouldRefresh = true;
        }
      });
    });
    
    if (shouldRefresh) {
      console.log("New products detected, refreshing variant data...");
      collectVariantData();
    }
  });
  
  // Observe the main content area for new products
  var mainContent = document.querySelector("main") || document.body;
  observer.observe(mainContent, { 
    childList: true, 
    subtree: true 
  });
  
  console.log("Color swatch handler initialized successfully");
});